import { render, staticRenderFns } from "./OAuthTutorialBanner.vue?vue&type=template&id=1bc07586&scoped=true"
import script from "./OAuthTutorialBanner.vue?vue&type=script&lang=js"
export * from "./OAuthTutorialBanner.vue?vue&type=script&lang=js"
import style0 from "./OAuthTutorialBanner.vue?vue&type=style&index=0&id=1bc07586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc07586",
  null
  
)

export default component.exports